import { IsInt, IsBoolean, IsString, MaxLength, ValidateNested, IsOptional, IsObject, Min, Max, IsDate } from 'class-validator';

import { AssemblyLocation } from '../settings/assembly-location/assembly-location';
import { DeliveryDistance } from '../geo';

import { Order } from './order';
import { IOrderExternalData } from './external-data/i-order-external-data';

export class OrderUpdateRequest implements Omit<
    Order, 'positions' | 'sum' | 'totalSum' | 'created' | 'updated' | 'statusUpdatedAt' | 'contrName' | 'userName' | 'dealerId' | 'priceTypeUuid' | 'paidOnline'
    | 'contrNeedDelivery' | 'personId' | 'uuid' | 'status' | 'shortNote'
> {
    @IsOptional()
    @IsInt()
    public id: number;

    @IsOptional()
    @IsInt()
    public contrId: number;

    @IsOptional()
    @IsInt()
    @Min(0)
    @Max(100)
    public discount: number;

    @IsOptional()
    @IsInt()
    public gaugerId: number;

    @IsOptional()
    @IsDate()
    public pickupDate: Date;

    @IsOptional()
    public externalData: IOrderExternalData;

    @IsOptional()
    @IsBoolean()
    public orderNeedDelivery: boolean;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    public comment: string;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    public contactPhone: string;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    public contactPerson: string;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    public pickupAddress: string;

    @IsOptional()
    @IsObject()
    @ValidateNested()
    public assemblyLocation: AssemblyLocation;

    @IsOptional()
    @IsObject()
    @ValidateNested()
    public deliveryDistance: DeliveryDistance;

    @IsOptional()
    @IsString()
    public serviceComment: string;

    constructor(data?: Partial<OrderUpdateRequest>) {
        this.id = data?.id;
        this.contrId = data?.contrId;
        this.discount = data?.discount;
        this.gaugerId = data?.gaugerId;
        this.pickupDate = typeof data?.pickupDate === 'string' ? new Date(data.pickupDate) : data?.pickupDate;
        this.externalData = data?.externalData;
        this.orderNeedDelivery = data?.orderNeedDelivery;
        this.comment = data?.comment;
        this.contactPhone = data?.contactPhone;
        this.contactPerson = data?.contactPerson;
        this.pickupAddress = data?.pickupAddress;
        this.assemblyLocation = data?.assemblyLocation && typeof data?.assemblyLocation === 'object'
            ? new AssemblyLocation(data.assemblyLocation) : data?.assemblyLocation;
        this.deliveryDistance = data?.deliveryDistance && typeof data?.deliveryDistance === 'object'
            ? new DeliveryDistance(data.deliveryDistance) : data?.deliveryDistance;
        this.serviceComment = data?.serviceComment;
    }
}
